import { jsx as o } from "react/jsx-runtime";
import { useCallback as p } from "react";
import { S as w, a as C, b } from "../../flow-delete-type-CzhAH86v.js";
import { mapTriggerOperationToLabel as h } from "./utils.js";
import { FlowCard as a } from "../card/Card.component.js";
import { FlowElementDropdown as F } from "../flow-element-dropdown/FlowElementDropdown.component.js";
import { equalsWhenLowerCased as D, useMergeThemeVariables as S } from "../../shared/utils.js";
const v = {
  INSERT: /* @__PURE__ */ o(b, {}),
  MODIFY: /* @__PURE__ */ o(C, {}),
  REMOVE: /* @__PURE__ */ o(w, {})
}, E = ({
  copies: n,
  apiDeclaration: d,
  trigger: e,
  triggerId: t,
  onDelete: r,
  theme: i
}) => {
  var m, s;
  const l = p(() => {
    r(t);
  }, [r, t]), f = v[e.operation], T = p(() => /* @__PURE__ */ o(
    F,
    {
      entityTypeId: t,
      entityTypeName: "Trigger",
      onDelete: l
    }
  ), [l, t]), c = e.tableId === "filedocument" ? "FileDocument" : e.tableId === "cloudfunction" ? "CloudFunction" : (s = (m = d.types) == null ? void 0 : m.find(
    (y) => D(y.id, e.tableId)
  )) == null ? void 0 : s.name, u = S(
    "flowCard",
    a.themeKeys,
    i
  );
  return /* @__PURE__ */ o(
    a,
    {
      icon: f,
      label: h(e.operation, n),
      leftPlateOffset: 65,
      renderMenuContent: T,
      value: n.tableDataChangeEventName(c),
      theme: u
    }
  );
}, I = E;
I.themeKeys = {
  ...a.themeKeys,
  flowCard: !0
};
export {
  I as Trigger
};
